import { render, staticRenderFns } from "./ViewPostureStatusBySpecimenId.vue?vue&type=template&id=9ad1b592&scoped=true"
import script from "./ViewPostureStatusBySpecimenId.vue?vue&type=script&lang=js"
export * from "./ViewPostureStatusBySpecimenId.vue?vue&type=script&lang=js"
import style0 from "./ViewPostureStatusBySpecimenId.vue?vue&type=style&index=0&id=9ad1b592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad1b592",
  null
  
)

export default component.exports